import { render, staticRenderFns } from "./ItemProjectForm.vue?vue&type=template&id=1f21e122&scoped=true"
import script from "./ItemProjectForm.vue?vue&type=script&lang=js"
export * from "./ItemProjectForm.vue?vue&type=script&lang=js"
import style0 from "./ItemProjectForm.vue?vue&type=style&index=0&id=1f21e122&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f21e122",
  null
  
)

export default component.exports